<template>
    <input
        ref="input"
        :class="['form-control', inputClass]"
        :type="type"
        :placeholder="placeholder"
        :value="modelValue"
        :disabled="disabled"
        :readonly="readonly"
        @keydown.enter="$emit('keydown:enter', $event)"
        @keydown.backspace="$emit('keydown:backspace', $event)"
        @input="$emit('update:modelValue', $event.target.value)"
        @paste="onPaste"
        @blur="$emit('blur')"
    >
    <span v-if="alert" :class="`form-text ${alertClass}`">{{ alert }}</span>
    <span :class="`form-text text-${valueLength > maxLength ? 'danger' : 'muted'}`" v-if="maxLength !== null">{{ valueLength }} / {{ maxLength }}</span>
</template>

<script>
export default {
    name: "Input",
    emits: ["update:modelValue", "keydown:enter", "keydown:backspace", "blur"],
    props: {
        modelValue: {
            default: '' // number
        },
        type: {
            type: String,
            default: 'text' // number
        },
        placeholder: {
            type: String,
            default: () => translate('components.input.placeholder')
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number,
            default: null
        },
        readonly: {
            type: Boolean,
            default: false
        },
        inputClass: {
            type: String,
            default: ''
        },
        alertClass: {
            type: String,
            default: 'text-danger'
        },
        alert: {
            type: String,
            default: ''
        }
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        onPaste(event) {
            if (this.type !== 'number') {
                return;
            }

            const pasted = event.clipboardData.getData('text');
            const converted = pasted.replace(',', '.');

            if (pasted === converted) {
                return;
            }

            event.preventDefault();
            this.$emit('update:modelValue', converted);
        }
    },
    computed: {
        valueLength() {
            return this.modelValue ? this.modelValue.length : 0;
        }
    }
}
</script>

<style scoped>
input[type=number] {
    text-align: right;
}
</style>
